import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ScenicFoodInfoCard',
    props: {
        tourisnInfo: {
            type: Object,
            default: function () { return ({}); }
        }
    },
    setup: function () {
        return {};
    },
});
